<script>
  import Modal from "../../components/Modal.svelte"
  import ubigeo from "../../services/ubigeo.js"
  import { BASE_URL } from "../../stores/BASE_URL"
  import { user } from "../../stores/User"
  import { createEventDispatcher } from "svelte"
  import Container from "../../components/Container.svelte"

  const dispatch = createEventDispatcher()

  export let cliente

  let isOpenModalDireccionVerificada = false
  let isSettingDireccionVerificada = false

  let cod_dep = "00"
  let cod_pro = "00"
  let cod_dis = "00"

  let departamentos = ubigeo.getDepartamento()
  let provincias = []
  let distritos = []

  let direccion = ""

  const handleAgregarDireccion = () => {
    isOpenModalDireccionVerificada = true
  }

  const updateDireccionVerificada = async () => {
    if (
      cod_dep === "00" ||
      cod_pro === "00" ||
      cod_dis === "00" ||
      direccion.trim() === ""
    ) {
      alert("Por favor, complete todos los campos.")
      return
    }

    isSettingDireccionVerificada = true

    const response = await fetch(`${BASE_URL}crm.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ops: "updateDireccionVerificada",
        id: cliente.id,
        direccion,
        ubigeo: `${cod_dep}${cod_pro}${cod_dis}`,
        tipo: "direccion",
        session_key: $user.session_key,
      }),
    })
    const data = await response.json()
    if (data.status === "ok") {
      direccion = ""
      dispatch("update")
      isOpenModalDireccionVerificada = false
    } else {
      console.error("Error al actualizar dirección verificada:", data.message)
    }
    isSettingDireccionVerificada = false
  }

  // Ubigeo
  const handleDepartamentoChange = () => {
    cod_pro = "00"
    cod_dis = "00"
    provincias = ubigeo.getProvincia(cod_dep)
  }

  const handleProvinciaChange = () => {
    cod_dis = "00"
    distritos = ubigeo.getDistrito(cod_dep, cod_pro)
  }
</script>

<Container>
  <div class="d-flex justify-content-between align-items-center">
    <h6 class="text-start">
      <i class="bi-geo-alt fg-secondary me-3"></i> Dirección verificada
    </h6>
    <button class="btn btn-sm fg-primary" on:click={handleAgregarDireccion}
      ><i class="bi bi-pencil-square"></i></button
    >
  </div>
  <div class="table-responsive">
    <table class="table table-striped table-sm small">
      <tbody>
        <tr>
          <td class="fg-secondary">Direccion</td>
          <td>{cliente.direccion}</td>
        </tr>
        <tr>
          <td class="fg-secondary">Departamento</td>
          <td>{cliente.departamento}</td>
        </tr>
        <tr>
          <td class="fg-secondary">Provincia</td>
          <td>{cliente.provincia}</td>
        </tr>
        <tr>
          <td class="fg-secondary">Distrito</td>
          <td>{cliente.distrito}</td>
        </tr>
        <tr>
          <td class="fg-secondary">Ubigeo</td>
          <td>{cliente.ubigeo == "000000" ? "" : cliente.ubigeo}</td>
        </tr>
      </tbody>
    </table>
  </div>
</Container>

<Modal
  isOpen={isOpenModalDireccionVerificada}
  on:close={() => (isOpenModalDireccionVerificada = false)}
  title="Agregar dirección"
>
  <div class="mb-3">
    <label for="direccion-departamento" class="form-label">Departamento</label>
    <select
      id="direccion-departamento"
      bind:value={cod_dep}
      on:change={handleDepartamentoChange}
      class="form-control form-control-sm"
    >
      <option value="00">· · · SELECCIONE · · ·</option>
      {#each departamentos as departamento}
        <option value={departamento.cod_dep}>
          {departamento.des_dep}
        </option>
      {/each}
    </select>
  </div>
  <div class="mb-3">
    <label for="direccion-provincia" class="form-label">Provincia</label>
    <select
      id="direccion-provincia"
      bind:value={cod_pro}
      on:change={handleProvinciaChange}
      class="form-control form-control-sm"
    >
      <option value="00">· · · SELECCIONE · · ·</option>
      {#each provincias as provincia}
        <option value={provincia.cod_pro}>
          {provincia.des_pro}
        </option>
      {/each}
    </select>
  </div>
  <div class="mb-3">
    <label for="direccion-distrito" class="form-label">Distrito</label>
    <select
      id="direccion-distrito"
      bind:value={cod_dis}
      class="form-control form-control-sm"
    >
      <option value="00">· · · SELECCIONE · · ·</option>
      {#each distritos as distrito}
        <option value={distrito.cod_dis}>
          {distrito.des_dis}
        </option>
      {/each}
    </select>
  </div>
  <div class="mb-3">
    <label for="direccion-direccion" class="form-label">Dirección</label>
    <input
      type="text"
      id="direccion-direccion"
      class="form-control form-control-sm"
      bind:value={direccion}
    />
  </div>
  <div class="mb-3 text-end">
    {#if isSettingDireccionVerificada}
      <button class="btn btn-solid theme-primary btn-sm disabled" disabled
        >Agregando...</button
      >
    {:else}
      <button
        class="btn btn-solid theme-primary btn-sm"
        on:click={updateDireccionVerificada}>Agregar</button
      >
    {/if}
  </div>
</Modal>
